<script lang="ts">
  import type { ClassValue, HTMLAttributes } from "svelte/elements"

  let {
    fill = 0,
    fillClass = "",
    ...props
  }: {
    /** In [0, 1] range */
    fill?: number
    fillClass?: ClassValue
  } & HTMLAttributes<HTMLDivElement> = $props()

  let mounted = $state(false)
  let filled = $derived.by(() => {
    if (fill < 0.33) return "none" as const // 0%
    if (fill < 1) return "partial" as const // ~25%
    return "full" as const // 100%
  })
</script>

<div
  {...props}
  class:mounted
  class={["relative aspect-[193/408] h-[calc(404/387*100%)] w-auto", props.class]}
>
  <svg
    viewBox="0 0 193 408"
    fill="none"
    stroke="#fff"
    stroke-width="3"
    stroke-miterlimit="10"
    stroke-linecap="round"
    xmlns="http://www.w3.org/2000/svg"
    class="absolute inset-0 h-full w-full"
  >
    <path d="M2 403.277V406" stroke-dasharray="2.723 5.446" stroke-dashoffset="4.223" /><path
      d="M13.2557 402.61L13.4946 405.891"
      stroke-dashoffset="4.789"
    /><path
      d="M24.2865 401.18L24.8486 405.006"
      stroke-dasharray="3.867 7.734"
      stroke-dashoffset="5.367"
    /><path
      d="M35.0504 399.015L36.02 403.372"
      stroke-dasharray="4.463 8.927"
      stroke-dashoffset="5.963"
    /><path
      d="M45.5613 396.156L47.0086 400.989"
      stroke-dasharray="5.045 10.09"
      stroke-dashoffset="6.545"
    /><path
      d="M55.7913 392.616L57.7726 397.885"
      stroke-dasharray="5.629 11.258"
      stroke-dashoffset="7.129"
    /><path
      d="M65.7119 388.436L68.2975 394.086"
      stroke-dasharray="6.214 12.427"
      stroke-dashoffset="7.714"
    /><path
      d="M75.3236 383.616L78.5556 389.593"
      stroke-dasharray="6.795 13.59"
      stroke-dashoffset="8.295"
    /><path
      d="M84.5839 378.197L88.5325 384.46"
      stroke-dasharray="7.404 14.808"
      stroke-dashoffset="8.904"
    /><path
      d="M93.4929 372.206L98.1863 378.673"
      stroke-dasharray="7.991 15.981"
      stroke-dashoffset="9.491"
    /><path
      d="M102.036 365.644L107.489 372.274"
      stroke-dasharray="8.584 17.169"
      stroke-dashoffset="10.084"
    /><path
      d="M110.173 358.563L116.44 365.29"
      stroke-dasharray="9.194 18.388"
      stroke-dashoffset="10.694"
    /><path
      d="M117.901 350.966L125.012 357.72"
      stroke-dasharray="9.807 19.615"
      stroke-dashoffset="11.307"
    /><path
      d="M125.208 342.892L133.162 349.605"
      stroke-dasharray="10.408 20.816"
      stroke-dashoffset="11.908"
    /><path
      d="M132.066 334.355L140.876 340.958"
      stroke-dasharray="11.01 22.02"
      stroke-dashoffset="12.51"
    /><path
      d="M138.459 325.369L148.127 331.796"
      stroke-dasharray="11.609 23.219"
      stroke-dashoffset="13.109"
    /><path
      d="M144.375 315.96L154.914 322.156"
      stroke-dasharray="12.225 24.451"
      stroke-dashoffset="13.725"
    /><path
      d="M149.771 306.171L161.182 312.053"
      stroke-dasharray="12.838 25.676"
      stroke-dashoffset="14.338"
    /><path
      d="M154.661 296.014L166.929 301.514"
      stroke-dasharray="13.445 26.889"
      stroke-dashoffset="14.945"
    /><path
      d="M159.004 285.489L172.114 290.554"
      stroke-dasharray="14.054 28.109"
      stroke-dashoffset="15.554"
    /><path
      d="M162.798 274.651L176.723 279.185"
      stroke-dasharray="14.645 29.289"
      stroke-dashoffset="16.145"
    /><path
      d="M166.001 263.514L180.742 267.462"
      stroke-dasharray="15.261 30.521"
      stroke-dashoffset="16.761"
    /><path
      d="M168.615 252.077L184.129 255.372"
      stroke-dasharray="15.86 31.72"
      stroke-dashoffset="17.36"
    /><path
      d="M170.61 240.395L186.883 242.968"
      stroke-dasharray="16.475 32.95"
      stroke-dashoffset="17.975"
    /><path
      d="M171.974 228.467L188.948 230.251"
      stroke-dasharray="17.067 34.135"
      stroke-dashoffset="18.567"
    /><path
      d="M172.69 216.336L190.34 217.248"
      stroke-dasharray="17.674 35.347"
      stroke-dashoffset="19.174"
    /><path d="M172.732 204H191" stroke-dasharray="18.268 36.536" stroke-dashoffset="19.768" /><path
      d="M172.69 191.664L190.34 190.752"
      stroke-dasharray="17.674 35.347"
      stroke-dashoffset="19.174"
    /><path
      d="M171.974 179.533L188.948 177.749"
      stroke-dasharray="17.067 34.135"
      stroke-dashoffset="18.567"
    /><path
      d="M170.61 167.606L186.883 165.032"
      stroke-dasharray="16.475 32.951"
      stroke-dashoffset="17.975"
    /><path
      d="M168.615 155.923L184.129 152.628"
      stroke-dasharray="15.86 31.72"
      stroke-dashoffset="17.36"
    /><path
      d="M166.001 144.487L180.742 140.538"
      stroke-dasharray="15.261 30.522"
      stroke-dashoffset="16.761"
    /><path
      d="M162.798 133.349L176.723 128.815"
      stroke-dasharray="14.645 29.289"
      stroke-dashoffset="16.145"
    /><path
      d="M159.004 122.511L172.114 117.446"
      stroke-dasharray="14.054 28.109"
      stroke-dashoffset="15.554"
    /><path
      d="M154.661 111.986L166.929 106.485"
      stroke-dasharray="13.445 26.89"
      stroke-dashoffset="14.945"
    /><path
      d="M149.771 101.829L161.182 95.9473"
      stroke-dasharray="12.838 25.675"
      stroke-dashoffset="14.338"
    /><path
      d="M144.375 92.0393L154.914 85.8442"
      stroke-dasharray="12.225 24.45"
      stroke-dashoffset="13.725"
    /><path
      d="M138.459 82.6311L148.127 76.2046"
      stroke-dasharray="11.609 23.218"
      stroke-dashoffset="13.109"
    /><path
      d="M132.066 73.645L140.876 67.0415"
      stroke-dasharray="11.01 22.02"
      stroke-dashoffset="12.51"
    /><path
      d="M125.208 65.108L133.162 58.3955"
      stroke-dasharray="10.408 20.816"
      stroke-dashoffset="11.908"
    /><path
      d="M117.901 57.0341L125.012 50.2808"
      stroke-dasharray="9.807 19.614"
      stroke-dashoffset="11.307"
    /><path
      d="M110.173 49.4365L116.44 42.7104"
      stroke-dasharray="9.193 18.386"
      stroke-dashoffset="10.693"
    /><path
      d="M102.036 42.3563L107.489 35.7256"
      stroke-dasharray="8.585 17.17"
      stroke-dashoffset="10.085"
    /><path
      d="M93.4929 35.7935L98.1863 29.3262"
      stroke-dasharray="7.991 15.982"
      stroke-dashoffset="9.491"
    /><path
      d="M84.5839 29.8027L88.5325 23.5396"
      stroke-dasharray="7.404 14.808"
      stroke-dashoffset="8.904"
    /><path
      d="M75.3236 24.384L78.5556 18.4067"
      stroke-dasharray="6.795 13.59"
      stroke-dashoffset="8.295"
    /><path
      d="M65.7119 19.564L68.2975 13.9136"
      stroke-dasharray="6.214 12.428"
      stroke-dashoffset="7.714"
    /><path
      d="M55.7913 15.384L57.7726 10.1147"
      stroke-dasharray="5.63 11.26"
      stroke-dashoffset="7.129"
    /><path
      d="M45.5613 11.8443L47.0086 7.01074"
      stroke-dasharray="5.046 10.091"
      stroke-dashoffset="6.546"
    /><path
      d="M35.0504 8.9849L36.02 4.62793"
      stroke-dasharray="4.464 8.927"
      stroke-dashoffset="5.964"
    /><path
      d="M24.2865 6.8201L24.8486 2.99414"
      stroke-dasharray="3.867 7.734"
      stroke-dashoffset="5.367"
    /><path
      d="M13.2557 5.39072L13.4946 2.10938"
      stroke-dasharray="3.29 6.58"
      stroke-dashoffset="4.79"
    /><path d="M2 4.7231V2" stroke-dasharray="2.723 5.446" stroke-dashoffset="4.223" />
  </svg>
  <svg
    class={[
      fillClass,
      `filled-${filled}`,
      "absolute inset-0 h-full w-full drop-shadow-[0px_0px_2.5px_currentColor]",
    ]}
    viewBox="0 0 193 408"
    fill="none"
    stroke="currentColor"
    stroke-width="3"
    stroke-miterlimit="10"
    stroke-linecap="round"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M2 403.277V406" stroke-dasharray="2.723 5.446" stroke-dashoffset="4.223" /><path
      d="M13.2557 402.61L13.4946 405.891"
      stroke-dasharray="3.29 6.579"
      stroke-dashoffset="4.79"
    /><path
      d="M24.2865 401.18L24.8486 405.006"
      stroke-dasharray="3.867 7.734"
      stroke-dashoffset="5.367"
    /><path
      d="M35.0504 399.015L36.02 403.372"
      stroke-dasharray="4.464 8.927"
      stroke-dashoffset="5.964"
    /><path
      d="M45.5613 396.156L47.0086 400.989"
      stroke-dasharray="5.045 10.09"
      stroke-dashoffset="6.545"
    /><path
      d="M55.7913 392.616L57.7726 397.885"
      stroke-dasharray="5.629 11.258"
      stroke-dashoffset="7.129"
    /><path
      d="M65.7119 388.436L68.2975 394.086"
      stroke-dasharray="6.214 12.427"
      stroke-dashoffset="7.714"
    /><path
      d="M75.3236 383.616L78.5556 389.593"
      stroke-dasharray="6.795 13.59"
      stroke-dashoffset="8.295"
    /><path
      d="M84.5839 378.197L88.5325 384.46"
      stroke-dasharray="7.404 14.808"
      stroke-dashoffset="8.904"
    /><path
      d="M93.4929 372.206L98.1863 378.673"
      stroke-dasharray="7.991 15.981"
      stroke-dashoffset="9.491"
    /><path
      d="M102.036 365.644L107.489 372.274"
      stroke-dasharray="8.584 17.169"
      stroke-dashoffset="10.084"
    /><path
      d="M110.173 358.563L116.44 365.29"
      stroke-dasharray="9.194 18.388"
      stroke-dashoffset="10.694"
    /><path
      d="M117.901 350.966L125.012 357.72"
      stroke-dasharray="9.807 19.615"
      stroke-dashoffset="11.307"
    /><path
      d="M125.208 342.892L133.162 349.605"
      stroke-dasharray="10.408 20.816"
      stroke-dashoffset="11.908"
    /><path
      d="M132.066 334.355L140.876 340.958"
      stroke-dasharray="11.01 22.02"
      stroke-dashoffset="12.51"
    /><path
      d="M138.459 325.369L148.127 331.796"
      stroke-dasharray="11.609 23.219"
      stroke-dashoffset="13.109"
    /><path
      d="M144.375 315.96L154.914 322.156"
      stroke-dasharray="12.225 24.451"
      stroke-dashoffset="13.725"
    /><path
      d="M149.771 306.171L161.182 312.053"
      stroke-dasharray="12.838 25.676"
      stroke-dashoffset="14.338"
    /><path
      d="M154.661 296.014L166.929 301.514"
      stroke-dasharray="13.444 26.889"
      stroke-dashoffset="14.944"
    /><path
      d="M159.004 285.489L172.114 290.554"
      stroke-dasharray="14.054 28.109"
      stroke-dashoffset="15.554"
    /><path
      d="M162.798 274.651L176.723 279.185"
      stroke-dasharray="14.645 29.289"
      stroke-dashoffset="16.145"
    /><path
      d="M166.001 263.514L180.742 267.462"
      stroke-dasharray="15.261 30.521"
      stroke-dashoffset="16.761"
    /><path
      d="M168.615 252.077L184.129 255.372"
      stroke-dasharray="15.86 31.72"
      stroke-dashoffset="17.36"
    /><path
      d="M170.61 240.395L186.883 242.968"
      stroke-dasharray="16.475 32.95"
      stroke-dashoffset="17.975"
    /><path
      d="M171.974 228.467L188.948 230.251"
      stroke-dasharray="17.067 34.135"
      stroke-dashoffset="18.567"
    /><path
      d="M172.69 216.336L190.34 217.248"
      stroke-dasharray="17.674 35.347"
      stroke-dashoffset="19.174"
    /><path d="M172.732 204H191" stroke-dasharray="18.268 36.536" stroke-dashoffset="19.768" /><path
      d="M172.69 191.664L190.34 190.752"
      stroke-dasharray="17.674 35.347"
      stroke-dashoffset="19.174"
    /><path
      d="M171.974 179.533L188.948 177.749"
      stroke-dasharray="17.067 34.135"
      stroke-dashoffset="18.567"
    /><path
      d="M170.61 167.606L186.883 165.032"
      stroke-dasharray="16.475 32.951"
      stroke-dashoffset="17.975"
    /><path
      d="M168.615 155.923L184.129 152.628"
      stroke-dasharray="15.86 31.72"
      stroke-dashoffset="17.36"
    /><path
      d="M166.001 144.487L180.742 140.538"
      stroke-dasharray="15.261 30.522"
      stroke-dashoffset="16.761"
    /><path
      d="M162.798 133.349L176.723 128.815"
      stroke-dasharray="14.645 29.289"
      stroke-dashoffset="16.145"
    /><path
      d="M159.004 122.511L172.114 117.446"
      stroke-dasharray="14.054 28.109"
      stroke-dashoffset="15.55"
    /><path
      d="M154.661 111.986L166.929 106.485"
      stroke-dasharray="13.445 26.89"
      stroke-dashoffset="14.945"
    /><path
      d="M149.771 101.829L161.182 95.9473"
      stroke-dasharray="12.838 25.675"
      stroke-dashoffset="14.338"
    /><path
      d="M144.375 92.0393L154.914 85.8442"
      stroke-dasharray="12.225 24.45"
      stroke-dashoffset="13.725"
    /><path
      d="M138.459 82.6311L148.127 76.2046"
      stroke-dasharray="11.609 23.218"
      stroke-dashoffset="13.109"
    /><path
      d="M132.066 73.645L140.876 67.0415"
      stroke-dasharray="11.01 22.02"
      stroke-dashoffset="12.51"
    /><path
      d="M125.208 65.108L133.162 58.3955"
      stroke-dasharray="10.408 20.816"
      stroke-dashoffset="11.908"
    /><path
      d="M117.901 57.0341L125.012 50.2808"
      stroke-dasharray="9.807 19.614"
      stroke-dashoffset="11.307"
    /><path
      d="M110.173 49.4365L116.44 42.7104"
      stroke-dasharray="9.193 18.386"
      stroke-dashoffset="10.693"
    /><path
      d="M102.036 42.3563L107.489 35.7256"
      stroke-dasharray="8.585 17.17"
      stroke-dashoffset="10.085"
    /><path
      d="M93.4929 35.7935L98.1863 29.3262"
      stroke-dasharray="7.991 15.982"
      stroke-dashoffset="9.491"
    /><path
      d="M84.5839 29.8027L88.5325 23.5396"
      stroke-dasharray="7.404 14.808"
      stroke-dashoffset="8.904"
    /><path
      d="M75.3236 24.384L78.5556 18.4067"
      stroke-dasharray="6.795 13.59"
      stroke-dashoffset="8.295"
    /><path
      d="M65.7119 19.564L68.2975 13.9136"
      stroke-dasharray="6.214 12.428"
      stroke-dashoffset="7.714"
    /><path
      d="M55.7913 15.384L57.7726 10.1147"
      stroke-dasharray="5.6295 11.259"
      stroke-dashoffset="7.1295"
    /><path
      d="M45.5613 11.8443L47.0086 7.01074"
      stroke-dasharray="5.046 10.091"
      stroke-dashoffset="6.546"
    /><path
      d="M35.0504 8.9849L36.02 4.62793"
      stroke-dasharray="4.464 8.927"
      stroke-dashoffset="5.964"
    /><path
      d="M24.2865 6.8201L24.8486 2.99414"
      stroke-dasharray="3.867 7.734"
      stroke-dashoffset="5.367"
    /><path
      d="M13.2557 5.39072L13.4946 2.10938"
      stroke-dasharray="3.29 6.58"
      stroke-dashoffset="4.79"
    /><path d="M2 4.7231V2" stroke-dasharray="2.723 5.446" stroke-dashoffset="4.223" />
  </svg>
</div>

<style lang="postcss">
  div.mounted > svg:nth-of-type(2) > path {
    transition: stroke-dashoffset 0.5s;
  }

  svg:nth-of-type(1) {
    mask: linear-gradient(
      to left,
      rgba(255, 255, 255, 1),
      rgba(255, 255, 255, 0.05) 36.82%,
      rgba(255, 255, 255, 0) 100%
    );

    & > path {
      @apply animate-[theme(transitionTimingFunction.DEFAULT)_300ms_1_forwards_draw];
    }

    @keyframes draw {
      100% {
        stroke-dashoffset: 0;
      }
    }

    & > path {
      &:nth-child(1) {
        animation-delay: 780ms;
      }

      &:nth-child(2) {
        animation-delay: 750ms;
      }

      &:nth-child(3) {
        animation-delay: 720ms;
      }

      &:nth-child(4) {
        animation-delay: 690ms;
      }

      &:nth-child(5) {
        animation-delay: 660ms;
      }

      &:nth-child(6) {
        animation-delay: 630ms;
      }

      &:nth-child(7) {
        animation-delay: 600ms;
      }

      &:nth-child(8) {
        animation-delay: 570ms;
      }

      &:nth-child(9) {
        animation-delay: 540ms;
      }

      &:nth-child(10) {
        animation-delay: 510ms;
      }

      &:nth-child(11) {
        animation-delay: 480ms;
      }

      &:nth-child(12) {
        animation-delay: 450ms;
      }

      &:nth-child(13) {
        animation-delay: 420ms;
      }

      &:nth-child(14) {
        animation-delay: 390ms;
      }

      &:nth-child(15) {
        animation-delay: 360ms;
      }

      &:nth-child(16) {
        animation-delay: 330ms;
      }

      &:nth-child(17) {
        animation-delay: 300ms;
      }

      &:nth-child(18) {
        animation-delay: 270ms;
      }

      &:nth-child(19) {
        animation-delay: 240ms;
      }

      &:nth-child(20) {
        animation-delay: 210ms;
      }

      &:nth-child(21) {
        animation-delay: 180ms;
      }

      &:nth-child(22) {
        animation-delay: 150ms;
      }

      &:nth-child(23) {
        animation-delay: 120ms;
      }

      &:nth-child(24) {
        animation-delay: 90ms;
      }

      &:nth-child(25) {
        animation-delay: 60ms;
      }

      &:nth-child(26) {
        animation-delay: 30ms;
      }

      &:nth-child(27) {
        animation-delay: 0ms;
      }

      &:nth-child(28) {
        animation-delay: 30ms;
      }

      &:nth-child(29) {
        animation-delay: 60ms;
      }

      &:nth-child(30) {
        animation-delay: 90ms;
      }

      &:nth-child(31) {
        animation-delay: 120ms;
      }

      &:nth-child(32) {
        animation-delay: 150ms;
      }

      &:nth-child(33) {
        animation-delay: 180ms;
      }

      &:nth-child(34) {
        animation-delay: 210ms;
      }

      &:nth-child(35) {
        animation-delay: 240ms;
      }

      &:nth-child(36) {
        animation-delay: 270ms;
      }

      &:nth-child(37) {
        animation-delay: 300ms;
      }

      &:nth-child(38) {
        animation-delay: 330ms;
      }

      &:nth-child(39) {
        animation-delay: 360ms;
      }

      &:nth-child(40) {
        animation-delay: 390ms;
      }

      &:nth-child(41) {
        animation-delay: 420ms;
      }

      &:nth-child(42) {
        animation-delay: 450ms;
      }

      &:nth-child(43) {
        animation-delay: 480ms;
      }

      &:nth-child(44) {
        animation-delay: 510ms;
      }

      &:nth-child(45) {
        animation-delay: 540ms;
      }

      &:nth-child(46) {
        animation-delay: 570ms;
      }

      &:nth-child(47) {
        animation-delay: 600ms;
      }

      &:nth-child(48) {
        animation-delay: 630ms;
      }

      &:nth-child(49) {
        animation-delay: 660ms;
      }

      &:nth-child(50) {
        animation-delay: 690ms;
      }

      &:nth-child(51) {
        animation-delay: 720ms;
      }

      &:nth-child(52) {
        animation-delay: 750ms;
      }

      &:nth-child(53) {
        animation-delay: 780ms;
      }
    }
  }

  svg:nth-of-type(2) {
    mask: linear-gradient(
      to left,
      rgba(255, 255, 255, 1),
      rgba(255, 255, 255, 0.1) 55%,
      rgba(255, 255, 255, 0)
    );

    & > path {
      transition: stroke-dashoffset 0.3s;
    }

    &.filled-partial > path:nth-child(n + 20):nth-child(-n + 33) {
      stroke-dashoffset: 0;
    }
    &.filled-full > path {
      stroke-dashoffset: 0;
    }
  }
</style>
